import { classes } from '../const';

const { isActive } = classes;

let allowedByCookieConst = false;

const getCookieValidation = $el => {
  const $$cookieName = $el.find('.cookie_2click').attr('data-cookie');

  if ($$cookieName) {
    let cookieValues = ''

    const nameEQ = "externalSources=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      if (c.indexOf(nameEQ) === 0) {
        cookieValues = c.substring(nameEQ.length, c.length);

        break;
      }
      while (c.charAt(0) === ' ') {

        c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
          cookieValues = c.substring(nameEQ.length, c.length);

          break;
        }
      }
    }

    let allowedByCookie = false;
    if ($('body').hasClass('is-IE')) {
      if (cookieValues.split(',').indexOf($$cookieName) > 0) {
        allowedByCookie = true;
      } else {
        allowedByCookie = false;
      }
    } else {
      allowedByCookie = cookieValues.split(',').includes($$cookieName)
    }

    return allowedByCookie;
  } 
    return allowedByCookieConst;
  
}

const openTabContent = $el => {
  const $frameHolder = $el.find('.js-map-frame-holder');
  const active = $frameHolder.closest('.map__tab-panel').find('.js-map-mark.is-active');
  let frameUrl = '';
  if (active.length === 0) {
    frameUrl = $frameHolder.closest('.map__tab-panel').find('.js-map-mark').first().data('iframe');
  } else {
    frameUrl = active.data('iframe');
  }


  allowedByCookieConst = getCookieValidation($el);

  if (allowedByCookieConst) {
    $frameHolder.html(`<iframe src="${frameUrl}"></iframe>`);
    $frameHolder.closest('.map').find('.modal_revoke').toggle(true);
  } else {
    $el.closest('.section').find('.cookie_2click').on('click', function () {
      $frameHolder.fadeOut(300);
      setTimeout(function () {
        $frameHolder.html(`<iframe src="${frameUrl}"></iframe>`);
        $frameHolder.closest('.map').find('.modal_revoke').toggle(true);
      }, 300)
      $frameHolder.fadeIn(300);
    })
  }

  $el.addClass(isActive);

};

const closeTabContent = $el => {
  $el.removeClass(isActive);
  setTimeout(() => {
    $el.find('.js-map-frame-holder iframe').remove();
  }, 1000);
};

const maps = () => {
  const $$maps = $('.js-map');

  $$maps.each((i, el) => {
    const $$tablinks = $(el).find('.js-map-tablink');
    const $$tabcontents = $(el).find('.js-map-tabcontent');
    const $$jumpMarks = $(el).find('.js-jump-marks');

    openTabContent($(el).find('.js-map-tabcontent.is-active'));

    $$tablinks.each((j, tablink) => {
      const tabId = $(tablink).data('tab');

      $(tablink).click(event => {
        event.preventDefault();
        $$tablinks.removeClass(isActive);
        $(tablink).addClass(isActive);

        $$tabcontents.each((k, tabContent) => {
          if ($(tabContent).data('tab') === tabId) {
            if (!$(tabContent).hasClass(isActive)) {
              openTabContent($(tabContent));
            }
          } else if ($(tabContent).hasClass(isActive)) {
              closeTabContent($(tabContent));
            }
        });
      });
    });

    $$jumpMarks.each((j, marks) => {
      const $$marks = $(marks).find('.js-map-mark');

      $$marks.each((k, mark) => {
        $(mark).click(event => {
          const frameUrl = $(mark).data('iframe');
          const frame = $(mark).closest('.map__tab-panel').find('.js-map-frame-holder');
          frame.fadeOut(300);
          const allowedByCookie = getCookieValidation(frame);

          if (allowedByCookie) {
            setTimeout(function () {
              frame.html(`<iframe src="${frameUrl}"></iframe>`);
            }, 300)
          } else {
            frame.closest('.section').find('.cookie_2click').on('click', function () {
              frame.fadeOut(300);
              setTimeout(function () {
                frame.html(`<iframe src="${frameUrl}"></iframe>`);
              }, 300)
              frame.fadeIn(300);
            })
          }
          frame.fadeIn(300);
          event.preventDefault();
          $$marks.removeClass(isActive);
          $(mark).addClass(isActive);
        });
      });
    });
  });
};

export default maps;
